import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component
import { devConfig } from 'config/config'; // Import development configuration

/**
 * ConfigurationBestShopView class extends JetView to create a specific view.
 */
export default class configurationBestShopView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        return {
            type: 'wide', // Layout type
            cols: [
                {
                    localId: 'inner:layout', // Local ID for the layout
                    type: 'wide', // Layout type
                    rows: [
                        {
                            view: 'tabbar', // Tab bar component
                            localId: 'tabbar', // Local ID for the tab bar
                            height: 43, // Height of the tab bar
                            options: [
                                {
                                    id: 'betShopManagement.configuration.changePassword', // Tab ID
                                    value: _('Cambiar Contraseña'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Visibility based on permissions
                                        'betShopManagementConfigurationChangePasswordMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-betShopManagementConfigurationChangePasswordMenu', // CSS class
                                },
                                {
                                    id: 'betShopManagement.configuration.generateToken', // Tab ID
                                    value: _('Generar Token'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Visibility based on permissions
                                        'betShopManagementConfigurationGenerateTokenMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-betShopManagementConfigurationGenerateTokenMenu', // CSS class
                                },
                                {
                                    id: 'betShopManagement.configuration.securityChanges', // Tab ID
                                    value: _('Seguridad Cambios'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Visibility based on permissions
                                        'betShopManagementConfigurationSecurityChangesMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-betShopManagementConfigurationSecurityChangesMenu', // CSS class
                                },
                                {
                                    id: 'betShopManagement.configuration.qrgoogle', // Tab ID
                                    value: _('QR Google'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Visibility based on permissions
                                        'betShopManagementConfigurationQrgoogleMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-betShopManagementConfigurationQrgoogleMenu', // CSS class
                                },
                                {
                                    id: 'betShopManagement.configuration.configNtc',
                                    value: _('Configuración NTC personalizada'),
                                    hidden: true,
                                    css: 'prm-betShopManagement'
                                }

                            ],
                        },
                        { $subview: true }, // Placeholder for subviews
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar'));

        this.on(this.app, "ntc:toggle", () => {
            const tabbar = this.$$('tabbar');
            const hasPermission = devConfig.getPermAction(
                'betShopManagement',
                'Menu'
            );

            if (hasPermission && this.app.config.showNtc === true) {
                tabbar.showOption('betShopManagement.configuration.configNtc');
            } else {
                tabbar.hideOption('betShopManagement.configuration.configNtc');
            }
        });
        if (typeof this.app.config.showNtc !== 'undefined') {
            this.app.callEvent("ntc:toggle");
        }
        this.on(this.app, 'person:select', (person) => {
            this.setParam('user', person.id, true);
        });

        webix.ready(() => {
            webix.attachEvent('onRotate', () => window.location.reload());
        });
    }

}

// FILE DOCUMENTED
